module.exports = __webpack_public_path__ + "static/6-4042864f91faf16279971e112354c987.jpeg";